import React from 'react';

import '../App.css';
export default function Menu() {
  return (
    <div>
    
      <div class="header-bar">
    <div class="contact-info">
    <span>
    <a href="mailto:info@insuranceadvisors.pk" class="email-link">
        <i class="fas fa-envelope"></i> info@insuranceadvisors.pk
    </a>
</span>

<span>
    <a href="tel:03111123026" class="phone-link">
        <i class="fas fa-phone-alt"></i> 03-111-123-026
    </a>
</span>

    </div>
    <div class="social-icons">
    <a href="https://wa.me/+923111123026" target="_blank">
    <i class="fab fa-whatsapp"></i>
</a>

<a href="https://www.facebook.com/share/19QhjhJrfz/" target="_blank">
    <i class="fab fa-facebook-f"></i>
</a>

<a href="https://www.instagram.com/insuranceadvisors.pk?igsh=MW0wdTRqbW92amNueQ== " target="_blank">
    <i class="fab fa-instagram"></i>
</a>

        {/* <a href="#"><i class="fab fa-linkedin-in"></i></a> */}
    </div>


</div>



<nav class="navbar navbar-expand-lg navbar-dark sticky-top">
    <img src='../assets/img/logo.png' width="220px"/>
    {/* <a class="navbar-brand" href="/">Insurance Advisors</a> */}
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" href="/">Home</a>
            </li>
           
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="insuranceDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Insurance
                </a>
                <div class="dropdown-menu custom-dropdown-menu" aria-labelledby="insuranceDropdown" id="jkl">
                    <a class="dropdown-item" href="/travel"> Travel  </a>
                    <a class="dropdown-item" href="/car"> Car </a>
                    <a class="dropdown-item" href="/bike"> Bike</a>
                    <a class="dropdown-item" href="/life"> Life </a>
                    <a class="dropdown-item" href="/health"> Health </a>

                </div>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle"  id="productsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Services
                </a>
                <div class="dropdown-menu custom-dropdown-menu" aria-labelledby="productsDropdown" id="jkl">
                    <a class="dropdown-item" href="/cartracker">Car Tracker</a>
                    <a class="dropdown-item" href="/claimsupport">Claim Support</a>
                </div>
            </li>

            <li class="nav-item">
                <a class="nav-link" href="/contact">Contact</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="/about">About</a>
            </li>

        </ul>
    </div>
</nav>
    </div>
  );
}
